// @ts-check

/** @typedef {import('../calendarVisitSchedule.schema').CalendarVisitSchedule} CalendarVisitSchedule */

import { createVisitPrescriptionSchedule } from '../calendarVisitSchedule.schema';

/**
 * Result type for normalizeVisitPrescriptionScheduleCooperative.
 * @typedef {Object} NormalizedVisitPrescriptionScheduleCooperativeResult
 * @property {number[]} ids - Array of padVisitId numbers.
 * @property {Record<number, CalendarVisitSchedule>} byPadVisitId - Mapping from padVisitId to its normalized CalendarVisitSchedule.
 */

/**
 * Normalizes an object of prescriptions grouped by padVisitId.
 * @param {CalendarVisitSchedule} visitPrescriptionSchedule - The input object where keys are IDs and values are schedule data.
 * @returns {NormalizedVisitPrescriptionScheduleCooperativeResult} Normalized schedule.
 */
export const normalizeVisitPrescriptionScheduleCooperative = visitPrescriptionSchedule => {
  /** @type {Record<number, CalendarVisitSchedule>} */
  const byPadVisitId = {};

  const id = visitPrescriptionSchedule.padVisitId;
  if (id) {
    byPadVisitId[id] = createVisitPrescriptionSchedule(visitPrescriptionSchedule);
  }

  return {
    ids: Object.keys(byPadVisitId).map(Number),
    byPadVisitId
  };
};
